// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.supportTicketForm {
  background: #ffffff;
  box-shadow: 0 2px 10px 1px rgba(105, 105, 105, 0.2);
  border-radius: 12px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
}
.supportTicketForm form {
  width: 100%;
  margin-top: 40px;
}
.supportTicketForm form label {
  color: #2d388b;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 5px;
}
.supportTicketForm form .p-inputtext {
  height: 45px;
  margin-bottom: 20px;
  border-radius: 6px;
}
.supportTicketForm form textarea {
  height: 250px;
  border-color: #ced4da;
  border-radius: 3px;
  margin-bottom: 20px;
}
.supportTicketForm .header-section {
  padding: 32px 32px 0 32px;
}
.supportTicketForm .header-section h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 30px;
  letter-spacing: -2px;
  color: #1E38A9;
}
.supportTicketForm .body-section {
  padding: 0px 32px 32px 32px;
}
.supportTicketForm .footer-section {
  border-top: 1px solid #D1D5DB;
  padding: 22px 32px;
}
.supportTicketForm .footer-section .flex {
  margin-left: auto;
}
.supportTicketForm .footer-section .flex .p-button {
  min-width: 236px;
}

.m-10 {
  margin: 10px 0;
}

.p-6 {
  padding: 6px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
